export const getRawHomeData = state => state.home.rawHomeData;
